/* Check for dog Breed Value */
if ($('#SingleOptionBreed').length) {    

  $('#SingleOptionBreed').on('change', function() {
    selectedBreed = this.value;
    //console.log(selectedBreed);
    //alert(selectedBreed);
    
    if ( selectedBreed == "Afghanhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Airedaleterrier") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Akita") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Alaskan husky") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Alaskan klee kai") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Alaskan malamute") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "American staffordshire terrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Amerikansk cocker spaniel") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Amstaff") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Appenzeller sennenhund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Australian cattledog") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Australian Cobberdog") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Australian kelpie") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Australian labradoodle") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Australian shepherd") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Australian stumpy tail cattle dog") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Australisk terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Barbet") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Basenji") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Basset hound") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Beagle") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Beagle-harrier") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Bearded Collie") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Belgisk vallhund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Berger picard") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Berner sennenhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Bichon frisé") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Bichon havanais") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Blodhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Border collie") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Borderterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Borzoi") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Bostonterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Boxer") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Brandlbracke") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Bullterrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Cairnterrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Cane Corso") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Cavalier King Charles spaniel") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Cavapoo") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Chihuahua") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Chinese crested dog") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Chow chow") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Cockapoo") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Cocker spaniel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Cockerpoo") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Collie") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Corgi") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Coton de tulear") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Dalmatiner") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Dansk-svensk gårdshund") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Dobermann") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Dogo Argentino") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Drever") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Dvärgpinscher") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Dvärgpudel") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Dvärgschnauzer") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Engelsk bulldog") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Engelsk bulldogg") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Engelsk cocker spaniel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Engelsk setter") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Engelsk springer spaniel") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Eurasier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Finsk lapphund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Finsk spets") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Finsk stövare") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Flat coated retriever") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Flatcoated retriever") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Foxterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Fransk bulldog") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Fransk bulldogg") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Golden retriever") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Goldendoodle") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Gordon setter") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Gordonsetter") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Grand danois") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Greyhound") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Gråhund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Hamiltonstövare") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Harrier") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Havanese") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Hovawart") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Irish soft coated wheaten terrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Irländsk setter") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Irländsk terrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Irländsk varghund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Irländsk vattenspaniel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Isländsk fårhund") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Italiensk vinthund") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Jack russel terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Jack russell terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Japanese chin") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Japansk spets") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Jämthund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Kai ken") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Kangal") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Karelsk björnhund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Katter") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Keeshond") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Kerry blue terrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "King Charles spaniel") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Kishu") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Kleiner münsterländer") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Kleinspitz") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Kooiker") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Kooikerhondje") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Korthårig vorsteh") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Kromfohrländer") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Labradoodle") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Labrador") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Labrador retriever") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Lagotto") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Lagotto romagnolo") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Landseer") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Lapsk vallhund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Leonberger") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Lhasa apso") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Malshipoo") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Malteser") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Maltipoo") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Manchester terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Maremmano abruzzese") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Mellanpudel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Mellempudel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Miniature American Shepherd") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Miniature american shepherd") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Mittelspitz") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Mops") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Newfoundlandshund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Norfolkterrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Norrbottenspets") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Norsk buhund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Norsk lundehund") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Norsk älghund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Norwich terrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Norwichterrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Nova scotia duck tolling retriever") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Nova Scotia duck tolling retriever") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Papillon") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Parson") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Pekingese") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Petit basset griffon vendéen") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Pharaoh hound") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Pinscher") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Pitbull") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Podenco") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Pointer") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Pomeranian") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Pomsky") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Portugisisk vattenhund") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Pudel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Pudelpointer") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Puli") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Pumi") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Pyrenéerhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Rhodesian ridgeback") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Rottweiler") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Saluki") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Samojed") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Samojedhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Schapendoes") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Schiller stövare") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Schnauzer") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Sealyhamterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Shar pei") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Shetland sheepdog") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Shiba") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Shiba inu") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Shih tzu") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Siberian husky") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Sibirisk husky") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Silkyterrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Släthårig foxterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Smålandsstövare") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Soft coated wheaten terrier") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Spansk vattenhund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Springer Spaniel") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Springerdoodle") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Staffordshire bullterrier") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Storpudel") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Strävhårig vorsteh") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Sussex spaniel") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Svensk Lapphund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Svensk lapphund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Svensk vallhund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Tax") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Tibetansk spaniel") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Tibetansk terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Toy pudel") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Toypudel") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Tysk jaktterrier") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Tysk schäfer") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Tysk schäferhund") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Tysk spets") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Vizsla") {$(".size-value").text(" XL ")}

    else if ( selectedBreed == "Volpino italiano") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Weimaraner") {$(".size-value").text(" XXL ")}

    else if ( selectedBreed == "Welsh corgi") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Welshterrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "West highland white terrier") {$(".size-value").text(" M ")}

    else if ( selectedBreed == "Whippet") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Yorkshireterrier") {$(".size-value").text(" S ")}

    else if ( selectedBreed == "Älghund") {$(".size-value").text(" L ")}

    else if ( selectedBreed == "Österrikisk pinscher") {$(".size-value").text(" XL ")}

    else {
      $(".size-value").text("")
    }

    const recomendedOption =document.querySelector(".psr-tool .size-wrapper .size-value").innerText.trim();
    document.querySelectorAll(".variant-input-wrap select option").forEach(function(option) {
      option.removeAttribute("selected");
      const splitedValue=option.value.split(":");
      if (splitedValue[0].trim()==recomendedOption) {
        option.selected = true;
        option.parentNode.dispatchEvent(new Event('change', { bubbles: true }));
      }
  });

  });
}